import { render, staticRenderFns } from "./LinkSet.vue?vue&type=template&id=37407652"
import script from "./LinkSet.vue?vue&type=script&lang=js"
export * from "./LinkSet.vue?vue&type=script&lang=js"
import style0 from "./LinkSet.vue?vue&type=style&index=0&id=37407652&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports